<template>
    <div>
        <loading v-if="loading"></loading>
        <div v-else>
            <div v-if="errorMessage">
                <o-notification type="danger" variant="danger" :closable="false">
                    {{errorMessage}}
                </o-notification>
            </div>
            <div v-else>
                <span v-html="html"></span>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, inject, computed, onMounted } from "vue";

    export default {
        props: {

        },
        setup(props, context) {
            const http = inject("$http");
            const moment = inject("$moment");
            const oruga = inject("$oruga");

            const loading = ref(true);
            const html = ref();
            const errorMessage = ref();

            const GetForm = async () => {
                errorMessage.value = null;
                loading.value = true;

                try {
                    const response = await http.get("/api/v2/widget/forms/intake-form");
                    html.value = response.data;
                }
                catch (err) {
                    console.error(err);
                    errorMessage.value = err?.response?.data || "You must log in to view this.";
                }

                loading.value = false;
            }

            onMounted(() => {
                GetForm();
            })

            return {
                loading,
                html,
                errorMessage
            }
        }
    }
</script>
